import { useFormikContext } from "formik";
import ShapeInterface from "../../Interfaces/ShapeInterface";
import { sectionSettings, cart, formatMoney } from "../../Helpers/WindowHelpers";

interface PriceDisplayInterface {
    shapes: ShapeInterface[]
}

const PriceDisplay = ({shapes}: PriceDisplayInterface) => {
    const { values } = useFormikContext<any>();
    const coverVariantPrice = document.querySelector('input.configurator_variant:checked')?.getAttribute('data-configurator-variant-price');
    const coverInput = document.querySelector('input.configurator_variant:checked') as HTMLInputElement;

    const addPriceObject = (object: any) => {
        if(typeof object != 'object') return;
        if(!object?.price) return;
        priceItems.push(parseInt(object.price) || 0);
    }

    const addPriceArray = (array: any[]) => {
        array.forEach((item) => addPriceObject(item));
    }

    let priceItems:number[] = [];

    for(let key in values) {
        if(Array.isArray(values[key])) {
            addPriceArray(values[key]);
            continue;
        }
        addPriceObject(values[key]);

    }
    priceItems.push(parseInt(coverVariantPrice) ?? 0);
    return (
        <div className="d--flex gap-10 sm--gap-5">
            <span className="total-label">{sectionSettings.label_total}:</span>
            <span className="h4 total-price">{formatMoney(priceItems.reduce((a, b) => a + b).toString())}</span>
        </div>
    )
}

export default PriceDisplay;